"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _elevation = require("@amzn/meridian-tokens/base/elevation");

var _toast = _interopRequireDefault(require("./toast"));

var _portal = _interopRequireDefault(require("../portal"));

var _listReset = _interopRequireDefault(require("./../_styles/list-reset"));

var _rtl = require("./../_utils/rtl");

var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles = function styles(alignmentHorizontal, alignmentVertical, position) {
  var _css;

  return (0, _emotion.css)(_listReset["default"], (_css = {
    position: position
  }, (0, _defineProperty2["default"])(_css, alignmentVertical, 0), (0, _defineProperty2["default"])(_css, "left", 0), (0, _defineProperty2["default"])(_css, "right", 0), (0, _defineProperty2["default"])(_css, "zIndex", _elevation.elevationModal + 1), (0, _defineProperty2["default"])(_css, "pointerEvents", "none"), (0, _defineProperty2["default"])(_css, "display", "flex"), (0, _defineProperty2["default"])(_css, "flexDirection", alignmentVertical === "bottom" ? "column-reverse" : "column"), (0, _defineProperty2["default"])(_css, "& > li", {
    display: "flex",
    flexDirection: "column",
    alignItems: {
      left: "flex-start",
      center: "center",
      right: "flex-end"
    }[(0, _rtl.getHorizontalDirection)(alignmentHorizontal)]
  }), (0, _defineProperty2["default"])(_css, "& > li > *", {
    pointerEvents: "all"
  }), _css));
};
/**
 * Animate toasts in and out at the top of the viewport.
 */


var Toaster = function Toaster(props) {
  var toasts = props.toasts,
      onCloseToast = props.onCloseToast,
      children = props.children; // Keep mounted toasts in a ref (toasts will stay mounted after being removed
  // from the toasts prop while they animate out). Using a ref allows us to add
  // new toasts to the list of mounted toasts without an extra render (which
  // would be necessary if we used state to hold mounted toasts).

  var mountedToasts = (0, _react.useRef)([]); // Because mounted toasts are stored in a ref we have to manually update state
  // when we remove a toast from the list (after it animates out). This state
  // allows us to do that manual refresh.

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      refresh = _useState2[1]; // Keep a ref to the latest value of onCloseToast. This is really important
  // because onCloseToast probably looks something like this:
  //   `const onCloseToast = id => toasts.filter(t => t.id !== id)`
  // If we call outdated versions of that kind of onCloseToast we could end up
  // bringing old toasts back to life and wreaking havoc on the current state.


  var onCloseToastRef = (0, _react.useRef)(onCloseToast);
  onCloseToastRef.current = onCloseToast; // Add new toasts and update existing toasts in mountedToasts

  toasts.forEach(function (toast) {
    // If the toast is new then add it to the *end* of the array. This prevents
    // toasts from being re-ordered after they're mounted. Start a timeout if
    // the toast requires it.
    if (!mountedToasts.current.some(function (mountedToast) {
      return mountedToast.toast.id === toast.id;
    })) {
      mountedToasts.current.unshift({
        toast: _objectSpread(_objectSpread({}, toast), {}, {
          onClose: function onClose() {
            return onCloseToastRef.current(toast.id);
          }
        }),
        timeout: toast.timeout && setTimeout(function () {
          return onCloseToastRef.current(toast.id);
        }, toast.timeout)
      });
    }
  }); // Cleanup timeouts for any mounted toasts when the toaster unmounts.

  (0, _react.useEffect)(function () {
    return function () {
      return mountedToasts.current.forEach(function (_ref) {
        var timeout = _ref.timeout;
        return clearTimeout(timeout);
      });
    };
  }, []); // Put the Toaster in a wrapper when position is fixed to avoid potential
  // style clashes from ancestors

  var Wrapper = (0, _react.useMemo)(function () {
    return props.position === "fixed" ? _portal["default"] : _react["default"].Fragment;
  }, [props.position]);
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement("ul", (0, _extends2["default"])({
    "aria-hidden": mountedToasts.current.length === 0 ? "true" : "false",
    className: styles(props.alignmentHorizontal, props.alignmentVertical, props.position)
  }, passThroughProps), mountedToasts.current.map(function (_ref2) {
    var toast = _ref2.toast,
        timeout = _ref2.timeout;
    return /*#__PURE__*/_react["default"].createElement(_toast["default"], {
      key: toast.id,
      exit: // If the toast is no longer being passed to us via `children` then
      // trigger the exit animation.
      !toasts.some(function (_ref3) {
        var id = _ref3.id;
        return id === toast.id;
      }),
      onAfterExit: function onAfterExit() {
        // After a toast is finished animating out, remove it from the
        // mounted toasts list and force a refresh.
        clearTimeout(timeout);
        mountedToasts.current = mountedToasts.current.filter(function (mountedToast) {
          return mountedToast.toast.id !== toast.id;
        });
        refresh({});
      },
      appearFrom: props.alignmentVertical
    }, children(toast));
  })));
};

Toaster.displayName = "Toaster";
Toaster.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * This function will be called any time the Toaster wants to render a toast.
   * The Toaster will pass an element from the `toasts` array to the function,
   * which should return a React element.
   *
   * The object passed to this function will be an exact copy of an element from
   * the toasts array, except that an `onClose` function will be added. If your
   * toast has a dismiss or close button, tie the provided `onClose` function to
   * that button. For example:
   *
   * <Toaster onCloseToast={onCloseToast} toasts={[{ id: "my-toast" }]}>
   *   {toast => (
   *     <Alert toast={true} onClose={toast.onClose}>My toast</Alert>
   *   )}
   * </Toaster>
   */
  children: _propTypes["default"].func.isRequired,

  /**
   * The array of toasts to render. Each element should be an object with a
   * string `id` property as well as any other data that is required by the
   * custom `children` function. Each object will be passed as-is to the
   * `children` function in order to render the toast. The individual elements
   * in this array cannot be modified, they can only be added or removed.
   *
   * An optional `timeout` property can be set on any element in this array in
   * order to auto-close a toast after a particular period of time. Set the
   * `timeout` property to the number of milliseconds that the toast should be
   * visible. The Toaster's `onCloseToast` callback will be executed with the toast's
   * id after the toast expires.
   *
   * Note that when new toasts are added to this array they will be rendered in
   * the chronological order in which they were added, not in the order in which
   * they appear in the array.
   */
  toasts: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    timeout: _propTypes["default"].number
  })).isRequired,

  /**
   * This function will be called any time a toast should be closed (e.g. when
   * the toast times out, or when the user clicks a toast's dismiss button). It
   * will be passed the id of the toast to close.
   */
  onCloseToast: _propTypes["default"].func.isRequired,

  /**
   * The toasts' horizontal alignment within the viewport.
   */
  alignmentHorizontal: _propTypes["default"].oneOf(["start", "center", "end"]),

  /**
   * The toasts' vertical alignment within the viewport.
   */
  alignmentVertical: _propTypes["default"].oneOf(["top", "bottom"]),

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * By default, Toaster appears toast from the top of the viewport (position "fixed").
   * Setting position to "absolute" allows the Toaster to be positioned to the
   * top of its closest "relative" ancestor. Read more about [CSS `position`](https://developer.mozilla.org/en-US/docs/Web/CSS/position).
   *
   * For example:
   * ```
   *  // Toaster will now appear toast from the top of this div
   *  <div style={{ position: "relative" }}>
   *    <Toaster toasts={toasts} onCloseToast={onCloseToast} position="absolute">
   *      {toast => <Alert {...toast} toast={true} width="100%" />}
   *    </Toaster>
   *  </div>
   * ```
   */
  position: _propTypes["default"].oneOf(["fixed", "absolute"])
} : {};
Toaster.defaultProps = {
  alignmentHorizontal: "center",
  alignmentVertical: "top",
  position: "fixed"
};
var _default = Toaster;
exports["default"] = _default;